import { Chip } from "@mui/material";
import { ColorsConstants } from "../../cssUtils/constants";

const AudienceFilterChip = ({ filter }) => {
  const formatValue = (field, value) => {
    if (field === "Marketing Opt In") {
      if (value === "true") {
        return "Yes";
      } else {
        return "No";
      }
    }
    
    if (field === "Tags") {
      if (Array.isArray(value)) {
        return value.join(", ");
      }
    }

    if (field === "Phone") {
      const stringValue = String(value ?? "").trim();
      if (!stringValue) return stringValue;
      if (stringValue.startsWith("+")) return stringValue;
      // Display country-code style values in E.164-like format for clarity.
      if (/^\d+$/.test(stringValue) && stringValue.length >= 11) {
        // Malaysia mobile formatting: +60 11-2222-3344
        if (stringValue.startsWith("60") && stringValue.length === 12) {
          return `+60 ${stringValue.slice(2, 4)}-${stringValue.slice(4, 8)}-${stringValue.slice(8)}`;
        }
        return `+${stringValue}`;
      }
      return stringValue;
    }

    return value;
  };

  return (
    <Chip
      variant="outlined"
      size="small"
      sx={{ mb: 0.5 }}
      label={
        <span>
          {filter.field}{" "}
          <span style={{ color: ColorsConstants.primaryBlue100, fontWeight: 600 }}>
            {filter.operator}
          </span>{" "}
          {formatValue(filter.field, filter.value)}
        </span>
      }
    />
  );
};

export default AudienceFilterChip;
